export const ALL_ROLES = ["employee", "support", "admin"];

export const ADMIN_ROLE = "admin";
export const SUPPORT_ROLE = "support";
export const EMPLOYEE_ROLE = "employee";
